import { render, staticRenderFns } from "./SsbSetupGrid.vue?vue&type=template&id=741031cb"
import script from "./SsbSetupGrid.vue?vue&type=script&lang=js"
export * from "./SsbSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports